import Api from './baseApi';

export default {
    getSettings: () => Api.get('/api/appSettings'),
    getSetting: (id) => Api.get(`/api/appSettings/${id}`),
    getSettingByKey: (key) => Api.get(`/api/appSettings/key/${key}`),
    putSetting: (setting) => Api.put(`/api/appSettings/${setting.id}`, setting),
    deleteSetting: (id) => Api.delete(`/api/appSettings/${id}`),
    postSetting: (setting) => Api.post('/api/appSettings', setting),
    getConfig: () => Api.get('/api/appSettings/config')
}

